import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type SwiperNavButtonProps = {
    icon: string;
    disabled: boolean;
    onClick?: any;
    className?: any;
    innerRef?: any;
    children?: ReactNode;
};

const SwiperNavButton = ({
    icon,
    disabled,
    onClick,
    className,
    innerRef,
    children
}: SwiperNavButtonProps) => (
    <div
        className={cn(
            "tw:text-primary tw:cursor-pointer tw:text-3xl",
            { "tw:cursor-default tw:opacity-20 tw:text-primary": disabled },
            className
        )}
        ref={innerRef}
        onClick={() => !disabled && onClick?.()}
    >
        {!children && <i className={cn(`las la-angle-${icon}`)} />}
        {!!children && children}
    </div>
);

export { SwiperNavButton };
